import Settings from '../src/containers/Settings'

export default Settings